import { withTheme } from 'styled-components';
import { AboutUsArea } from './AboutUsArea';
export default withTheme(AboutUsArea);
